import script from "./SfxTableTdStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTableTdStatus.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTd,QIcon});
